<div class="login" *ngIf="false">
    <div class="login__left"></div>
    <div class="login__right">
        <div class="login__wrapper">
            <img class="img-responsive" [src]="client.getLogoURL()" alt="{{client.getSiteName()}}">

            <div class="maintenance">
                <h1><i class="fal fa-exclamation-triangle"></i> Maintenance</h1>
                <div class="col-12 p-2">
                    <p class="lead text-black-50">
                        This site is currently unavailable as maintenance is in progress. We'll be back shortly.
                    </p>
                </div>
            </div>

            <footer class="site-footer">
                <p class="copyright" [innerHTML]="copyright"></p>
            </footer>

        </div>
    </div>
</div>
